import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../../context";

export const ForSectionContainer = styled.div<{
  rooTheme: Theme;
  lightBg: boolean;
}>`
  ${tw`z-10 mx-auto md:px-2.5`}
  background:   ${({ rooTheme, lightBg }) =>
    lightBg && rooTheme === "dark"
      ? tw`bg-white`
      : lightBg && rooTheme === "light"
      ? tw`bg-basebackground`
      : !lightBg && rooTheme === "dark"
      ? tw`bg-basebackground`
      : !lightBg && rooTheme === "light"
      ? tw`bg-white`
      : tw`bg-basebackground`};
`;

export const ForSectionSec = styled.div<{ lightBg: boolean; rooTheme: Theme }>`
  ${tw`max-w-[100vw] mx-auto lg:px-20 font-clash`}

  @media screen and (max-width:1024px) {
    width: calc(100vw - 100px);
  }

  @media screen and (max-width: 768px) {
    width: calc(100vw - 70px);
  }

  @media screen and (max-width: 500px) {
    width: calc(100vw - 50px);
  }

  ${({ rooTheme, lightBg }) =>
    lightBg && rooTheme === "dark"
      ? tw`bg-white`
      : lightBg && rooTheme === "light"
      ? tw`bg-basebackground`
      : !lightBg && rooTheme === "dark"
      ? tw`bg-basebackground`
      : !lightBg && rooTheme === "light"
      ? tw`bg-white`
      : tw`bg-basebackground`};

  ${tw`py-5 lg:py-20`}
  @media screen and (max-width: 768px) {
    ${tw`pt-14`}
  }
`;

export const ForSectionRow = styled.div<{ imgStart?: boolean }>`
  ${tw`flex flex-wrap items-start justify-between`}
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;

export const ForSectionColumn = styled.div`
  // ${tw`items-center px-4`}
  margin-bottom: 15px;
  padding-left: 15px;
  // flex: 1;
  // max-width: 50%;
  // flex-basis: 50%;

  @media screen and (min-width: 768px) {
    ${tw`justify-center px-0`}
    max-width: 50%;
    flex-basis: 50%;
    justify-content: center;
  }
  @media screen and (min-width: 2048px) {
    ${tw`justify-center px-96`}
    justify-content: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 480px;
  padding-top: 0;
  align-self: center;
  justify-self: center;

  @media screen and (max-width: 768px) {
    padding-bottom: 15px;
  }
`;

export const ImgWrapper = styled.div<{ start?: string }>`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? "flex-start" : "flex-end")};
  @media screen and (max-width: 768px) {
    margin-top: 15px;
  }
`;

export const TopLine = styled.div<{ rooTheme?: Theme }>`
  ${tw`text-base leading-4 font-medium font-clash mb-1.5`}
  ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`text-buttondefault` : tw`text-buttondefault`};
`;

export const Img = styled.img`
  ${tw`cursor-pointer`}
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  horizontal-align: end;
  display: inline-block;
  max-height: 500px;
`;

export const Heading = styled.h1<{ rooTheme?: Theme; lightBg?: boolean }>`
  ${tw`text-4xl leading-10 font-semibold font-clash mb-2.5`}
  ${({ rooTheme, lightBg }) =>
    lightBg && rooTheme === "dark"
      ? tw`text-heroColor`
      : lightBg && rooTheme === "light"
      ? tw`text-white`
      : !lightBg && rooTheme === "dark"
      ? tw`text-white`
      : !lightBg && rooTheme === "light"
      ? tw`text-heroColor`
      : tw`text-heroColor`};
`;

export const Subtitle = styled.p<{ rooTheme?: Theme; lightBg?: boolean }>`
  ${tw`text-sm leading-5 font-normal font-clash mb-0.5 pt-2`}
  max-width: 440px;
  ${({ rooTheme, lightBg }) =>
    lightBg && rooTheme === "dark"
      ? tw`text-heroColor`
      : lightBg && rooTheme === "light"
      ? tw`text-white`
      : !lightBg && rooTheme === "dark"
      ? tw`text-white`
      : !lightBg && rooTheme === "light"
      ? tw`text-heroColor`
      : tw`text-heroColor`};
`;

export const ListContainer = styled.div<{ rooTheme?: Theme }>`
  ${tw`flex items-center my-4`}
`;

export const ListText = styled.p<{ rooTheme?: Theme; lightBg?: boolean }>`
  ${tw`text-base not-italic font-semibold leading-5 font-clash`}
  ${({ rooTheme, lightBg }) =>
    lightBg && rooTheme === "dark"
      ? tw`text-heroColor`
      : lightBg && rooTheme === "light"
      ? tw`text-white`
      : !lightBg && rooTheme === "dark"
      ? tw`text-white`
      : !lightBg && rooTheme === "light"
      ? tw`text-heroColor`
      : tw`text-heroColor`};
`;

export const ListImageContainer = styled.div<{
  rooTheme?: Theme;
  lightBg?: boolean;
}>`
  ${tw`flex items-center justify-center w-10 h-10 mr-4 rounded-full`}
  ${({ rooTheme, lightBg }) =>
    lightBg && rooTheme === "dark"
      ? tw`bg-heroColor`
      : lightBg && rooTheme === "light"
      ? tw`bg-white`
      : !lightBg && rooTheme === "dark"
      ? tw`bg-white`
      : !lightBg && rooTheme === "light"
      ? tw`bg-heroColor`
      : tw`bg-heroColor`};
`;
